<template>
  <Head :title="page.title" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <static-page 
            :page="page" 
            :user="auth.user"
            :client="client"
            :show-schedule-demo="true"
          ></static-page>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  page: Object,
  auth: Object,
  client: Object
});
</script>

